import styled from 'styled-components';

interface ContainerProps {
  open: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: block;
  visibility: ${props => (props.open ? '' : 'hidden')};
  width: 60vw;
  min-width: ${props => (props.open ? '60%' : '0')};
  max-width: 935px;
  z-index: 1;
  transition: 0.5s;
  background-color: ${props => props.theme.gray0};
  padding: 0 12px;
  font-family: ${props => props.theme.fontFamily};
`;

export const Title = styled.header`
  height: 28px;
  font-size: 20px;
  line-height: 26px;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const CloseIcon = styled.div`
  cursor: pointer;
  font-size: 24px;
  i {
    margin-right: 4px;
  }
`;

export const TitleSection = styled.div`
  padding: 20px 0 0 8px;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const Body = styled.div`
  overflow-y: hidden;
  overflow-x: auto;
  border-bottom: 1px ${props => props.theme.altGray2} solid;
`;

export const ActionsSection = styled.div`
  padding: 12px 0;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
  button {
    margin: 5px;
  }
`;

export const Subtitle = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${props => props.theme.gray50};
  margin-top: 4px;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-bottom: 8px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
